import React, { FC, useMemo } from 'react'
import { FlexColumn } from 'components/Flex'
import { TextButton } from 'components/Button'
import { HorizontalLine, Spacer } from 'components/Utility'
import { DefaultStockType } from 'types/schedule'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getStoreRef } from 'reducks/auth/selectors'
import { FirebaseDocRefType } from 'firebase/index'
import { DayOfWeekType } from 'lib/daysOfWeek'
import { getHolidays } from 'reducks/store/selectors'
import { StockUnionType } from 'types/stock'
import { StoreDefaultScheduleType } from 'types/storeDefault'
import StoreDefaultStockFormWrapper from './StoreDefaultStockFormWrapper'

type Props = {
  addDefaultStock: (ref: FirebaseDocRefType, type: StockUnionType) => void
  addSchedule: (type: StockUnionType) => void
  deleteDefaultStock: (ref: FirebaseDocRefType, defaultStockIndex: number, type: StockUnionType) => void
  deleteSchedule: (index: number, type: StockUnionType) => void
  handleDefaultStocks: (
    defaultStock: DefaultStockType,
    index: number,
    scheduleRef?: FirebaseDocRefType,
    type?: StockUnionType
  ) => void
  handleHoursToDeadline?: (dateToDeadline: string, timeToDeadline: string, ref?: FirebaseDocRefType) => void
  schedules: StoreDefaultScheduleType[]
  selectDaysOfWeek: (dayOfWeek: DayOfWeekType, index: number, type: StockUnionType | '') => void
  selectAllDaysOfWeek: (daysOfWeek: DayOfWeekType[], index: number, type: StockUnionType | '') => void
  unselectAllDaysOfWeek: (index: number, type: StockUnionType | '') => void
  type: StockUnionType
}

const DefaultMultiDefaultStockForm: FC<Props> = (props) => {
  const {
    addDefaultStock,
    addSchedule,
    deleteDefaultStock,
    deleteSchedule,
    handleDefaultStocks,
    handleHoursToDeadline,
    schedules,
    selectDaysOfWeek,
    selectAllDaysOfWeek,
    unselectAllDaysOfWeek,
    type,
  } = props

  const holidays = useSelector((state: State) => getHolidays(state))

  const businessDays: DayOfWeekType[] = useMemo(() => {
    const dayOfWeeks: DayOfWeekType[] = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'hol']
    return dayOfWeeks.filter((dayOfWeek) => !holidays.includes(dayOfWeek))
  }, [holidays])

  const remainingDaysOfWeek: DayOfWeekType[] = useMemo(() => {
    const set: Set<DayOfWeekType> = new Set()
    for (let i = 0; i < schedules.length; i = (i + 1) | 0) {
      const schedule = schedules[i]
      schedule.days_of_week.map((dayOfWeek) => set.add(dayOfWeek))
    }
    const accumulatedDaysOfWeek = Array.from(set)
    return businessDays.filter((businessDay) => !accumulatedDaysOfWeek.includes(businessDay))
  }, [schedules, businessDays])

  return (
    <div>
      {schedules.map((schedule, index) => {
        const otherSchedules = schedules.filter((_, i) => i !== index)
        const selectableDaysOfWeek = businessDays.filter((businessDay) => {
          return otherSchedules.every((schedule) => !schedule.days_of_week.includes(businessDay))
        })
        return (
          <React.Fragment key={schedule.schedule_ref?.id}>
            {index !== 0 && (
              <>
                <HorizontalLine verticalMargin={0} />
                <Spacer size={12} />
              </>
            )}
            <StoreDefaultStockFormWrapper
              addDefaultStock={addDefaultStock}
              deleteDefaultStock={deleteDefaultStock}
              deleteSchedule={deleteSchedule}
              handleDefaultStocks={handleDefaultStocks}
              handleHoursToDeadline={handleHoursToDeadline}
              isShownDeleteIcon={true}
              schedule={schedule}
              index={index}
              selectableDaysOfWeek={selectableDaysOfWeek}
              selectDaysOfWeek={selectDaysOfWeek}
              selectAllDaysOfWeek={() => selectAllDaysOfWeek(selectableDaysOfWeek, index, type)}
              unselectAllDaysOfWeek={() => unselectAllDaysOfWeek(index, type)}
              type={type}
            />
          </React.Fragment>
        )
      })}
      <FlexColumn alignItems={'center'}>
        {
          // 全ての曜日が選択済みか、必須項目を選択していない場合は追加させない
          remainingDaysOfWeek.length === 0 ||
          schedules.some((schedule) => {
            return (
              schedule.default_stocks.some((defaultStock) => defaultStock.pickupable_time === '') ||
              schedule.days_of_week.length === 0
            )
          }) ? (
            <TextButton
              disabled={true}
              iconPath={'/icon/grey/plus.svg'}
              label={'別の曜日の設定を追加する'}
              onClick={() => addSchedule(type)}
            />
          ) : (
            <TextButton
              iconPath={'/icon/blue/plus.svg'}
              label={'別の曜日の設定を追加する'}
              onClick={() => addSchedule(type)}
            />
          )
        }
      </FlexColumn>
    </div>
  )
}

export default DefaultMultiDefaultStockForm
